import React, { type PropsWithChildren } from 'react';
import { PeriodContext } from 'context/index';
import facade from 'context/PeriodContext/facade';

export const PeriodContextComponent: React.FC<PropsWithChildren> = ({ children }) => {
   return <PeriodContext.Provider value={facade.context$}>{children}</PeriodContext.Provider>;
};

export default PeriodContextComponent;
